<template>
    <div class="MarketOverview">
        <MobileNav :page_title="nav_title" v-if="isUserloggedIn"></MobileNav>
        <RetailNavbar style="position: fixed; top: 0; width: 100%; z-index: 5;" v-else>
        </RetailNavbar>
        <div class="widget-outer-section">

            <div class="widget-third-row">
                <div class="title-section">
                    <div class="title" style="margin-bottom: 15px;">Stocks Heatmap</div>
                </div>
                <div class="widget-column">
                    <div class="tradingview-widget-container">
                        <div class="tradingview-widget-container__widget" ref="tradingWidgetThird"></div>
                    </div>
                </div>
                <div class="tradingview-widget-copyright"><a href="https://www.tradingview.com/" rel="noopener nofollow"
                        target="_blank"><span class="blue-text">Track all markets on
                            TradingView</span></a></div>
            </div>

            <div class="widget-first-row">
                <!-- <div class="widget-column widget-column-left gainers-losers">
                    <div class="title-section">
                        <div class="title">Top 5</div>
                        <div class="sub-title">Gaining, Losing, and most active stocks for the day.</div>
                    </div>
                    <div class="tradingview-widget-container">
                        <div class="tradingview-widget-container__widget" ref="topGainerLosers"></div>
                    </div>
                    <div class="tradingview-widget-copyright"><a href="https://www.tradingview.com/"
                            rel="noopener nofollow" target="_blank"><span class="blue-text">Track all markets on
                                TradingView</span></a></div>
                </div> -->

                <div class="widget-column widget-column-right overview">
                    <div class="title-section">
                        <div class="title">Market Overview</div>
                        <div class="sub-title">when you need to take a macro look at the markets.</div>
                    </div>
                    <div class="tradingview-widget-container">
                        <div class="tradingview-widget-container__widget" ref="tradingWidgetSecond"></div>
                    </div>
                    <div class="tradingview-widget-copyright"><a href="https://www.tradingview.com/"
                            rel="noopener nofollow" target="_blank"><span class="blue-text">Track all markets on
                                TradingView</span></a></div>
                </div>

            </div>

            <!-- <div class="widget-second-row">
                <div class="title-section">
                    <div class="title left-margin-10" style="margin-bottom: 15px;">IPO</div>
                </div>
                <div>
                    <iframe class='img-fluid mx-auto' src='https://www.chittorgarh.com/ipo/ipo_gadgets_live.asp'
                        style='border:none;overflow:hidden;width:100%;height:400px;'>
                    </iframe>

                </div>
            </div> -->
            <div
    style="
      margin: 20px;
    "
  >
    <p
      style="
        font-family: Arial, sans-serif;
        line-height: 1.8;
        color: #4a4a4a;
        background-color: #f9f9f9;
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 15px;
        font-size: 14px;
      "
    >
      <strong>Note:</strong> StockAnts has partnered with TradingView for its widgets, a comprehensive trading platform 
      offering valuable market insights and real-time market data. With its assistance, users can conveniently track 
      the price of <a href="https://www.tradingview.com/symbols/CBOT_MINI-YM1!/" style="color: #2962FF; text-decoration: none;" target="__blank">Dow Futures</a> and stay informed about other relevant market trends.
    </p>
  </div>

        </div>

    </div>
</template>

<script>
import RetailNavbar from "../components/RetailSideCompo/RetailNavbar.vue";
import MobileNav from "@/components/MobileNav.vue";

export default {
    name: "MarketOverview",
    components: {
        MobileNav,
        RetailNavbar
    },
    data() {
        return {
            nav_title: "Experts Recommendations",
            userProfile: {},
        }
    },
    mounted() {
        if (localStorage.getItem("profile")) {
            this.userProfile = JSON.parse(localStorage.getItem("profile"));
        }
        // Ensure refs are ready before loading the TradingView widget
        this.$nextTick(() => {
            this.loadTradingViewWidget();
        });
    },
    methods: {
        loadTradingViewWidget() {

            if (this.$refs.topGainerLosers) {
                const gainersLosersWidgetScript = document.createElement("script");
                gainersLosersWidgetScript.type = "text/javascript";
                gainersLosersWidgetScript.async = true;
                gainersLosersWidgetScript.src =
                    "https://s3.tradingview.com/external-embedding/embed-widget-hotlists.js";
                gainersLosersWidgetScript.innerHTML = JSON.stringify({
                    colorTheme: "light",
                    dateRange: "12M",
                    exchange: "BSE",
                    showChart: true,
                    locale: "in",
                    largeChartUrl: "",
                    isTransparent: false,
                    showSymbolLogo: true,
                    showFloatingTooltip: false,
                    width: "400",
                    height: "550",
                    plotLineColorGrowing: "rgba(41, 98, 255, 1)",
                    plotLineColorFalling: "rgba(41, 98, 255, 1)",
                    gridLineColor: "rgba(240, 243, 250, 0)",
                    scaleFontColor: "rgba(19, 23, 34, 1)",
                    belowLineFillColorGrowing: "rgba(41, 98, 255, 0.12)",
                    belowLineFillColorFalling: "rgba(41, 98, 255, 0.12)",
                    belowLineFillColorGrowingBottom: "rgba(41, 98, 255, 0)",
                    belowLineFillColorFallingBottom: "rgba(41, 98, 255, 0)",
                    symbolActiveColor: "rgba(41, 98, 255, 0.12)",
                });
                this.$refs.topGainerLosers.appendChild(gainersLosersWidgetScript);
            }

            if (this.$refs.tradingWidgetSecond) {
                const secondWidgetScript = document.createElement("script");
                secondWidgetScript.type = "text/javascript";
                secondWidgetScript.async = true;
                secondWidgetScript.src =
                    "https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
                secondWidgetScript.innerHTML = JSON.stringify({
                    colorTheme: "light",
                    dateRange: "12M",
                    showChart: true,
                    locale: "en",
                    width: "100%",
                    height: "500px",
                    largeChartUrl: "",
                    isTransparent: false,
                    showSymbolLogo: true,
                    showFloatingTooltip: false,
                    plotLineColorGrowing: "rgba(41, 98, 255, 1)",
                    plotLineColorFalling: "rgba(41, 98, 255, 1)",
                    gridLineColor: "rgba(240, 243, 250, 0)",
                    scaleFontColor: "rgba(19, 23, 34, 1)",
                    belowLineFillColorGrowing: "rgba(41, 98, 255, 0.12)",
                    belowLineFillColorFalling: "rgba(41, 98, 255, 0.12)",
                    belowLineFillColorGrowingBottom: "rgba(41, 98, 255, 0)",
                    belowLineFillColorFallingBottom: "rgba(41, 98, 255, 0)",
                    symbolActiveColor: "rgba(41, 98, 255, 0.12)",
                    tabs: [
                        {
                            title: "Forex",
                            symbols: [
                                { s: "FX:EURUSD", d: "EUR to USD" },
                                { s: "FX:GBPUSD", d: "GBP to USD" },
                            ],
                        },
                    ],
                });
                if (this.$refs.tradingWidgetSecond.firstChild) {
                    this.$refs.tradingWidgetSecond.removeChild(this.$refs.tradingWidgetSecond.firstChild);
                }
                this.$refs.tradingWidgetSecond.appendChild(secondWidgetScript);
            }
            if (this.$refs.tradingWidgetThird) {

                const thirdWidgetScript = document.createElement("script");
                thirdWidgetScript.type = "text/javascript";
                thirdWidgetScript.async = true;
                thirdWidgetScript.src =
                    "https://s3.tradingview.com/external-embedding/embed-widget-stock-heatmap.js";
                thirdWidgetScript.innerHTML = JSON.stringify({
                    exchanges: [],
                    dataSource: "SENSEX",
                    grouping: "sector",
                    blockSize: "market_cap_basic",
                    blockColor: "change",
                    locale: "en",
                    symbolUrl: "",
                    colorTheme: "light",
                    hasTopBar: false,
                    isDataSetEnabled: false,
                    isZoomEnabled: true,
                    hasSymbolTooltip: true,
                    isMonoSize: false,
                    width: "100%",
                    height: "100%"
                });
                this.$refs.tradingWidgetThird.appendChild(thirdWidgetScript);
            }
        },
    },
    computed: {
        isUserloggedIn() {
            return this.userProfile && Object.keys(this.userProfile).length > 0;
        },
    }
};
</script>

<style lang="scss" scoped>
.MarketOverview {
    width: 100%;
    padding-top: 60px;
    padding-bottom: 100px;

    .widget-outer-section {

        .title-section {
            .title {
                font-size: 25px;
                font-weight: 700;
                margin-bottom: 5px;
                margin-top: 40px;
            }

            .sub-title {
                font-size: 12px;
                font-weight: 500;
                color: #818181;
                margin-bottom: 20px;
            }
        }

        .widget-first-row {
            padding: 0px 5%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .gainers-losers {
                width: 35%;
            }

            .overview {
                width: 62%;
            }

            .tv-embed-widget-wrapper__body {
                border-radius: 12px !important;
            }
        }

        .widget-second-row {
            margin-top: 20px;
            padding: 0px 4%;


            iframe {
                min-height: 462px !important;
                width: 100%;

                .container-fluid {
                    .card {
                        border-radius: 30px !important;
                    }
                }
            }

            #dvFooterAd {
                display: none;
            }
        }

        .widget-third-row {
            padding: 0px 5%;
        }


    }

    @media screen and (max-width:1284px) {
        .widget-outer-section .widget-first-row {
            flex-direction: column;

            .gainers-losers {
                width: 100%;
            }

            .overview {
                width: 100%;
            }

            .widget-column-right {
                margin-left: 0px;
            }

            .widget-column-left {
                margin-right: 0px;
            }
        }

    }


}
</style>

<style lang="scss">
.MarketOverview {
    .widget-column-left {
        margin-right: 20px;
    }

    .widget-column-right {
        margin-left: 20px;
    }

    .tradingview-widget-container__widget {
        div {
            width: 100% !important;
            height: 620px !important;
        }
    }

    iframe {
        border-radius: 12px;
    }


    .widget-second-row {
        .card-header:first-child {
            border-radius: 30px;
        }



        iframe {
            .container-fluid {}
        }

    }

    .widget-third-row {

        .tv-embed-widget-wrapper__body,
        iframe {
            border-radius: 12px !important;
        }

    }
}
</style>